import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/common/LoadingSpinner';

const Dashboard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="large" text="Loading dashboard..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to appropriate dashboard based on user role
  switch (user.role) {
    case 'super_admin':
      return <Navigate to="/super-admin" replace />;
    case 'company_admin':
      return <Navigate to="/company-admin" replace />;
    case 'user':
      return <Navigate to="/user-dashboard" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default Dashboard;